export default {
  white: '#ffffff',
  black: '#000',
  grey: '#202020',
  lightGrey: '#636363',
  red: '#D1343E',
}
